import debounce from 'lodash/debounce'

const $faqs = $('.faq-section')

const setupToggle = () => {
  $(document).on('click', '.faq-item__question', (e) => {
    const $current = $(e.currentTarget).closest('.faq-item').find('.faq-item__answer').slideToggle('slow')
    $('.faq-item__answer').not($current).slideUp()
  })
}

const setupEqualHeights = () => {
  $('.faq-items--left li').each((index, el) => {
    const neighbor = $('.faq-items--right li').eq(index)

    $(el).find('.faq-item__question').css('height', 'auto')
    $(neighbor).find('.faq-item__question').css('height', 'auto')

    if (neighbor.length) {
      const myHeight = $(el).find('.faq-item__question').outerHeight()
      const neighborHeight = $(neighbor).find('.faq-item__question').outerHeight()
      const tallestHeight = Math.max(myHeight, neighborHeight)

      if (window.innerWidth >= 640) {
        $(el).find('.faq-item__question').css('height', `${tallestHeight}px`)
        $(neighborHeight).find('.faq-item__question').css('height', `${tallestHeight}px`)
      }
      else {
        $(el).find('.faq-item__question').css('height', 'auto')
        $(neighbor).find('.faq-item__question').css('height', 'auto')
      }
    }
  })
}

$(window).on('resize', debounce(setupEqualHeights, 200))

export default {
  can: () => $faqs.length,
  run: () => {
    setupToggle()
    setupEqualHeights()
  }
}
